<template>
  <div
    class="parent"
    v-if="matchEntities(['NETHERLANDS'])"
    :center-items="!displayLearnMoreLink"
  >
    <picture class="image">
      <source type="image/webp" :srcset="require('@/' + webp)" />
      <img
        alt="Two people smiling in converstation with a qwello pole in the
      background"
        class="image"
        :src="require('@/' + jpg)"
      />
    </picture>
    <div class="external-form-parent">
      <ExternalFormCTAButton />
    </div>
    <p v-if="displayLearnMoreLink" class="learn-more">
      <router-link :to="{ path: `/${locale}/procesbeschrijving` }">{{
        $t('homepage.form_learn')
      }}</router-link>
    </p>
    <p class="question">
      {{ $t('homepage.cta_question') }}
    </p>
  </div>
</template>
<script>
import i18n from '../../i18n';
import matchEntities from '../../shared/entityHelpers';
import ExternalFormCTAButton from './StartScreen/ExternalFormCTAButton.vue';

export default {
  data() {
    return {
      mobile: window.innerWidth < 768,
      locale: i18n.locale,
    };
  },
  props: ['displayLearnMoreLink'],
  components: { ExternalFormCTAButton },
  computed: {
    jpg() {
      if (this.mobile) {
        return 'assets/homePage/form-cta-bg-mobile.jpg';
      }
      return 'assets/homePage/form-cta-bg.jpg';
    },
    webp() {
      if (this.mobile) {
        return 'assets/homePage/form-cta-bg-mobile.webp';
      }
      return 'assets/homePage/form-cta-bg.webp';
    },
  },
  methods: {
    checkForMobile() {
      if (window.innerWidth < 768 && !this.mobile) {
        this.mobile = true;
        return;
      }
      if (window.innerWidth >= 768 && this.mobile) {
        this.mobile = false;
      }
    },
    matchEntities,
  },
  mounted() {
    window.addEventListener('resize', this.checkForMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkForMobile);
  },
};
</script>

<style scoped>
.parent {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  min-height: 375px;
}
.question {
  grid-column: 2;
  grid-row: 1;
  letter-spacing: 2.4px;
  color: #ffffff;
  opacity: 1;
  width: 80%;
}
.external-form-parent {
  grid-column: 2;
  grid-row: 2;
}
.learn-more {
  grid-area: 1/1;
  grid-column: 2;
  grid-row: 3;
  font-family: Lato;
  letter-spacing: 0.16px;
  color: #ffdf22;
}
.question,
.learn-more {
  font-size: 16px;
}

.image {
  display: block;
  grid-column: 1/-1;
  grid-row: 1/-1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  font-family: Lato;
}
.question,
.learn-more,
.external-form-parent {
  justify-self: center;
}
.question {
  align-self: flex-end;
}
.learn-more {
  align-self: flex-start;
}
.external-form-parent {
  align-self: center;
}
@media (min-width: 768px) {
  .parent[center-items] {
    grid-template-rows: repeat(4, 1fr);
  }
  .parent[center-items] .question {
    grid-row: 2;
  }
  .parent[center-items] .external-form-parent {
    grid-row: 3;
  }
  .external-form-parent {
    align-self: center;
    justify-self: center;
  }
  .question {
    width: max-content;
  }
  .question,
  .learn-more {
    font-size: 20px;
    align-self: center;
    justify-self: center;
  }
}
</style>
